import { IconClose, Content, Wrapper } from './styled'
import { animated, easings, useSpring } from '@react-spring/web'
import { ReactHintModal } from 'component/Modal/HintModal'
import { useCallback } from 'react'
import { ButtonWrapper, ConfirmButton } from 'component/Modal/ConfirmModal/Styled'
import { Styles } from 'react-modal'

export default function ChannelModal({
  isOpen,
  link,
  onClose,
  onOk,
}: {
  isOpen: boolean
  link: string
  onClose: () => void
  onOk: (link: string) => void
}) {
  const styles: Styles = {
    overlay: {
      zIndex: 101,
      backgroundColor: 'rgba(16, 4, 27, 0.5)',
      width: '100vw',
      height: '100vh',
    },
    content: {
      width: '7.55rem',
      height: '3rem',
      transformOrigin: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '0.25rem',
      transition: 'transform 0.3s ease-out',
    },
  }
  const springStyles = useSpring({
    config: { duration: 150, easing: easings.easeInCubic },
    width: '100%',
    height: isOpen ? '100%' : '0',
    opacity: isOpen ? 1 : 0.2,
  })

  const onConfirm = useCallback(() => {
    onOk(link)
  }, [link, onOk])

  return (
    <>
      {isOpen ? (
        <ReactHintModal
          contentLabel="Hint Modal"
          isOpen={isOpen}
          style={styles}
          shouldCloseOnOverlayClick={false}
          onRequestClose={onClose}
        >
          <animated.div style={springStyles}>
            <Wrapper>
              <IconClose onClick={onClose} />
              <Content>
                支付链接取得成功
              </Content>
              <ButtonWrapper>
                <ConfirmButton onClick={onConfirm}>前往支付</ConfirmButton>
              </ButtonWrapper>
            </Wrapper>
          </animated.div>
        </ReactHintModal>
      ) : (
        <></>
      )}
    </>
  )
}
